import ApiBase from "./base";

export const _SERVICE_AREA_URL = "service-area";

export async function getServiceAreaOptions() {
    const response = await ApiBase.get(`${_SERVICE_AREA_URL}`);

    return response.items ?? [];
}
